import Vue from 'vue'
import Router from 'vue-router'
import { changeTitle} from '@/util/index.js'
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/themeFamilyMaster',
      name: 'themeFamilyMaster',
      component: () => import('./views/themeFamilyMaster/index.vue'),
      meta: { title: '大师全家福' }
    }, {
      path: '/themeForLove',
      name: 'themeForLove',
      component: () => import('./views/themeForLove/index.vue'),
      meta: { title: '致爱照' }
    },
    {
      path: '/themeYunFu',
      name: 'themeYunFu',
      component: () => import('./views/themeYunFu/index.vue'),
      meta: { title: '孕妇照' }
    },
    {
      path: '/themePet',
      name: 'themePet',
      component: () => import('./views/themePet/index.vue'),
      meta: { title: '宠物照' }
    },
    {
      path: '/theme/:name/:platform?',
      name: 'themeA',
      component: () => import('./views/themeApage/index'),
      meta: { title: '风格展示' }
    },
    {
      path: '/necmt/get',
      name: 'necmtGet',
      component: () => import('./views/NECMThing/index.vue'),
      meta: { title: '云音乐联名饰品提货' }
    },
    {
      path: '/theme101',
      name: 'theme101',
      component: () => import('./views/theme101/index.vue'),
      meta: { title: '101种美探索之旅 ' }
    },
    {
      path: '/newTheme101',
      name: 'newTheme101',
      component: () => import('./views/newTheme101/index.vue'),
      meta: { title: '101种美 ' }
    }
  ]
})

router.afterEach((to, from) => {
  // 修改页面title
  changeTitle(to.meta.title)
})

export default router
